import { ImCheckmark } from 'react-icons/im';

import { QuestionSearchItem } from '@core/types/types.common';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@frontend/components/ui/avatar';
import { Answer } from '@frontend/shared/components/Answer';
import { QuestionVerified } from '@frontend/shared/components/Question/Verified/QuestionVerified';
import { useDirectoryUser } from '@frontend/shared/hooks/useDirectory';

export interface DuplicateQuestionProps {
  question: QuestionSearchItem;
}

export function DuplicateQuestion({ question }: DuplicateQuestionProps) {
  const user = useDirectoryUser(question.verified_by);

  return (
    <div className="first:mt-4 [&:not(:first-child)]:mt-10">
      <div className="flex items-center">
        <div className="relative">
          <Avatar className="h-[26px] w-[26px] mr-1">
            <AvatarImage src={user?.image} alt={user?.name} />
            <AvatarFallback>{user?.name?.charAt(0)}</AvatarFallback>
          </Avatar>
          <div
            className="absolute bottom-0 right-0 bg-purple-500 rounded-full border border-white flex items-center justify-center"
            style={{ width: '0.75em', height: '0.75em' }}
          >
            <ImCheckmark className="w-2 h-2 text-white" />
          </div>
        </div>
        <p className="font-medium w-full pr-2 ml-2">{question.title}</p>
      </div>
      <div className="pl-[38px] pt-1">
        <Answer
          question={question}
          editable={false}
          style={{ padding: 0, paddingBottom: 0, minHeight: 'auto' }}
        />
        <div className="h-2" />
        <QuestionVerified question={question} />
      </div>
    </div>
  );
}
